// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/seeds/dashboard-v2/wizards/import-map.yaml
// Generator: tools/v2-gen/v2genwiz.py
// Regenerate via: make v2-generate-wizards
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-wizard-generator.md
// for override-block doctrine (imports / helpers / submit).

import { useNavigate } from "react-router-dom";
import { WizardHost } from "./WizardHost";
import { importMapManifest } from "../generated/wizardManifests";
import { apiClient } from "../api/client";
// override-block:imports BEGIN
// override-block:imports END

// override-block:helpers BEGIN
// override-block:helpers END

export interface ImportMapWizardProps {
  open: boolean;
  onClose: () => void;
}

export function ImportMapWizard({ open, onClose }: ImportMapWizardProps) {
  const navigate = useNavigate();
  // TODO (Phase 1B / migration): api_endpoint 'POST /imports/{import_batch_id}/execute'
  // embeds values-substituted path param(s) ['import_batch_id'] — the default
  // single-call body below is wrong for this wizard. Replace the
  // override-block:submit content with the multi-phase API logic.
  // override-block:submit BEGIN
  // CHG-1324 — manifest's api_endpoint `POST /imports/{import_batch_id}/execute`
  // embeds a values-substituted path param, so this wizard is a 2-phase
  // call: POST /imports first (with source_file + entity_type) to create
  // the batch, then POST /imports/{id}/execute (with column_mapping +
  // schedule fields) to execute it. Migrated verbatim from the CHG-1247
  // hand-rolled ImportMapWizard.tsx body.
  const onSubmitRequest = async (values: Record<string, unknown>) => {
    // Phase 1 — create the import batch with source_file + entity_type.
    const createResp = await apiClient().post<{ id: string }>("/imports", {
      source_file: values.source_file,
      entity_type: values.entity_type,
    });
    const importBatchId = createResp.data.id;
    // Phase 2 — execute with column_mapping + schedule fields.
    const execResp = await apiClient().post<{ id: string }>(
      `/imports/${importBatchId}/execute`,
      {
        column_mapping: values.column_mapping,
        run_at: values.run_at,
        notify_email: values.notify_email,
      },
    );
    onClose();
    navigate(`/imports/${execResp.data.id}`);
  };
  // override-block:submit END
  return (
    <WizardHost
      manifest={importMapManifest}
      open={open}
      onClose={onClose}
      onSubmitRequest={onSubmitRequest}
    />
  );
}
